import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Spinner, Row, Col } from "react-bootstrap";
import { useGetSchoolNotificationList } from "../../../../hooks/school/notification/useGetSchoolNotificationList";
import "./Notification.css";
import { handleSmartBack } from "../../../../utils/navigationHelper";

export const NotificationDetail = () => {
  const { batch_id } = useParams();
  const navigate = useNavigate();

  const { notifications, loading, error, getSentNotifications } =
    useGetSchoolNotificationList();

  useEffect(() => {
    getSentNotifications({
      filters: { batch_id },
      all_info: 1,
    });
  }, [batch_id]);

  const notification = notifications?.[0];

  if (loading)
    return (
      <div className="page-center">
        <Spinner animation="border" />
      </div>
    );

  if (error) return <div className="error-box">{error}</div>;
  if (!notification) return null;

  return (
    <div className="notification-page">
      {/* Top Section */}
      <div className="page-header">
        <div>
          <h2 className="page-title">{notification.title}</h2>
          <p className="page-sub">
            Batch ID: {notification.batch_id} •{" "}
            {new Date(notification.created_at).toLocaleString()}
          </p>
        </div>

        <Button className="primary-gradient-btn" onClick={() => handleSmartBack(navigate, "/school/notifications")}>
          Back
        </Button>
      </div>

      {/* Description Card */}
      <div className="soft-card lavender">
        <h6 className="section-title">Message</h6>
        <p className="section-text">{notification.description}</p>
      </div>

      {/* Stats Row */}
      <Row className="mt-4 g-4">
        <Col md={3}>
          <div className="soft-card green">
            <div className="stat-value">{notification.total_recipients}</div>
            <div className="stat-label">Total Recipients</div>
          </div>
        </Col>

        <Col md={3}>
          <div className="soft-card blue">
            <div className="stat-value">{notification.total_read}</div>
            <div className="stat-label">Read</div>
          </div>
        </Col>

        <Col md={3}>
          <div className="soft-card peach">
            <div className="stat-value">{notification.total_unread}</div>
            <div className="stat-label">Unread</div>
          </div>
        </Col>

        <Col md={3}>
          <div className="soft-card grey">
            <div className="stat-value">{notification.total_dismissed}</div>
            <div className="stat-label">Dismissed</div>
          </div>
        </Col>
      </Row>

      {/* Recipients */}
      <div className="soft-card mt-4">
        <h6 className="section-title">Recipients</h6>
        <div className="recipient-grid">
          <div className="tag-container">
            {notification.receiver_names?.split(",").map((name, index) => (
              <span key={index} className="fb-tag">
                {name.trim()}
              </span>
            ))}
          </div>

          <div>
            <span className="mini-label">Roles</span>
            <div>{notification.receiver_roles}</div>
          </div>

          <div>
            <span className="mini-label">Total Students</span>
            <div>{notification.total_students}</div>
          </div>
        </div>

        {/* Media Section */}
        {notification.media && notification.media.length > 0 && (
          <div className="soft-card mt-4">
            <h6 className="section-title">Attachments</h6>

            <div className="media-grid">
              {notification.media.map((file, index) => {
                const fileUrl = file.signed_url; // 👈 Direct signed URL
                const ext = file.name.split(".").pop().toLowerCase();

                // IMAGE FILES
                if (["png", "jpg", "jpeg", "webp"].includes(ext)) {
                  return (
                    <div key={index} className="media-card">
                      <img src={fileUrl} alt={file.name} />
                    </div>
                  );
                }

                // PDF FILE
                if (ext === "pdf") {
                  return (
                    <div key={index} className="media-card pdf-card">
                      <div className="pdf-icon">📄</div>
                      <div className="file-name">{file.name}</div>
                      <a
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="primary-gradient-btn small-btn"
                      >
                        Open PDF
                      </a>
                    </div>
                  );
                }

                // OTHER FILE TYPES
                return (
                  <div key={index} className="media-card pdf-card">
                    <div className="file-name">{file?.url}</div>
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="primary-gradient-btn small-btn"
                    >
                      Download
                    </a>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
